<template>
  <v-tabs class="sub-menu" slider-color="primary" height="64" style="margin-bottom: 15px;">
    <v-tab class="sub-menu-item" to="/delegation-advance" v-if="isExtendedAdvancesEnabled">
      <v-icon class="sub-menu-item-icon">fa-money-bill-alt</v-icon>
      {{ $t("delegation.menu.advance") }}
    </v-tab>
    <v-tab class="sub-menu-item" to="/delegation-order" v-if="isDelegationOrderEnabled">
      <v-icon class="sub-menu-item-icon">send</v-icon>
      {{ $t("delegation.menu.order") }}
    </v-tab>
    <v-tab class="sub-menu-item" to="/delegation">
      <v-icon class="sub-menu-item-icon">assignment</v-icon>
      {{ $t("delegation.menu.settlement") }}
    </v-tab>
    <v-tab to="/delegation-info" class="sub-menu-item">
      <v-icon class="sub-menu-item-icon">info</v-icon>
      {{ $t("delegation.menu.info") }}
    </v-tab>
    <v-tab class="sub-menu-item" to="/settings/users" v-if="isWnbUser">
      <v-icon class="sub-menu-item-icon">settings</v-icon>
      {{ $t("delegation.menu.administration") }}
    </v-tab>
  </v-tabs>
</template>

<script>
export default {
  name: "DelegationMenu",
  computed: {
    isWnbUser() {
      return this.$store.getters["isWnbUser"];
    },
    isDelegationOrderEnabled() {
      let userProperty = this.$store.getters["userProperties"];
      return userProperty.system_settings.delegation_order_type === 2 || userProperty.system_settings.delegation_order_type === 3;
    },
    isExtendedAdvancesEnabled() {
      let userProperty = this.$store.getters["userProperties"];
      return userProperty.system_settings.delegation_advance_flow === 2;
    }
  }
};
</script>

<style scoped>
.sub-menu-item {
  font: bold 16px Merriweather, serif;
  text-transform: none;
}

.sub-menu-item-icon {
  margin-right: 15px;
}
</style>
